import script from "./sellerReport.vue?vue&type=script&setup=true&lang=js"
export * from "./sellerReport.vue?vue&type=script&setup=true&lang=js"

import "./sellerReport.vue?vue&type=style&index=0&id=46edcd16&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46edcd16"]])

export default __exports__